module.exports = __webpack_public_path__ + "img/wmpc_logo.00d7412d.png";